/**
 * Overlay stacking — one scale.
 *
 * Host apps raise sheets above the page (scrim `z-[200]`, panel `z-[210]`)
 * so they clear a detail takeover at `z-[100]`. Package popovers / selects /
 * menus used to default to `z-50` and painted behind those panels, which is
 * why hosts forked the primitives.
 *
 * `className` on a popover popup cannot fix stacking: it lands inside the
 * positioner's `isolate` context. Put the z on the positioner
 * (`positionerClassName` still replaces the default).
 *
 * Nested Select inside a Popover (Filter, header funnels) must sit one step
 * above the parent overlay or the list paints behind it.
 */
export const SURFACE_SCRIM_CLASS = "z-[200]";
export const SURFACE_PANEL_CLASS = "z-[210]";
export const OVERLAY_POSITIONER_CLASS = "isolate z-[300]";
export const OVERLAY_NESTED_POSITIONER_CLASS = "isolate z-[310]";
